import AxiosClient from "../../../services/axios.services";

class StrategicPillarServices {
  getStrategicPillar = (params) =>
    AxiosClient.get("/api/app/evaluacion_objetivos_pilares_estrategicos/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  getStrategicPillarById = (id) =>
    AxiosClient.get(`/api/app/evaluacion_objetivos_pilares_estrategicos/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  saveStrategicPillar = (data) =>
    AxiosClient.post("/api/app/evaluacion_objetivos_pilares_estrategicos/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editStrategicPillar = (id, data) =>
    AxiosClient.put(`/api/app/evaluacion_objetivos_pilares_estrategicos/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteStrategicPillar = (id) =>
    AxiosClient.delete(`/api/app/evaluacion_objetivos_pilares_estrategicos/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new StrategicPillarServices();
